import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.timers.js";
export default (function (context, inject) {
  var plugin = function plugin(content) {
    var styles = document.getElementsByTagName('style');
    var head = _toConsumableArray(styles).map(function (style) {
      return style.outerHTML;
    }).join('');
    var page = window.open('about:blank', 'print_preview');
    page.document.write("\n        <!DOCTYPE html>\n          <html>\n            <head>\n              ".concat(head, "\n              <style>\n                html {\n                  overflow-x: visible;\n                  overflow-y: visible;\n                }\n\n                body {\n                  pointer-events: none\n                }\n\n                ::-webkit-scrollbar {\n                  display: none;\n                }\n              </style>\n            </head>\n            <body>").concat(content, "</body>\n          </html>\n        "));
    setTimeout(function () {
      page.document.close();
      page.focus();
      page.print();
      // page.close()
    }, 1000);
  };
  inject('print', plugin);
});